import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ParticipanteService } from '@app/services/participante.service';
import { ParticipanteLista, ParticipanteListaFiltros } from '@app/models/participante.model';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from "@app/models/util/paginacao";
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';
import debounce from '@app/utils/debounce';

@Component({
  selector: 'app-participante-lista',
  templateUrl: './participante-lista.component.html',
})
export class ParticipanteListaComponent implements OnInit {
  
  paginacao: Paginacao = new Paginacao(1, 0, 5, 10);
  loading: boolean = true;
  pesquisa = new ParticipanteListaFiltros();
  lstParticipante: ParticipanteLista[] = [];
  bsModalRef: BsModalRef;
  podeEditarCliente: boolean = false;
  _pagina = 1;

  constructor(
    private participanteService: ParticipanteService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(ToastrService) public toastr: ToastrService
  ) {
    this.router.events.subscribe(() => window.scrollTo(0, 0));
    this.pesquisa.ativo;
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
    this.pesquisa.buscaTexto = params['busca']; 
   });
    this.obterTodos(this.pesquisa, 1);
  }

  pesquisar() {
    this.obterTodos(this.pesquisa, 1);
    this.pesquisa.ativo;
    this.paginacao.paginaAtual = 1;
  }
  
  onKeyPress(event: KeyboardEvent) {
    if (this.pesquisa.buscaTexto.length >= 3 || this.pesquisa.buscaTexto.length == 0) {
      this.obterTodos(this.pesquisa, 1);
    }
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(pesquisa: ParticipanteListaFiltros, pagina: number) {
    
     this._pagina = pagina;
     this.pesquisa.buscaTexto;

     this.participanteService.obterLista(pesquisa, pagina)
        .toPromise().then(data => {
         this.loading = false;
         this.lstParticipante = data.Dados,
         this.paginacao.totalDeItens = data.Total
      },
        erro => {
          this.loading = false;
          this.toastr.warning("Realize a pesquisa novamente.")
        });
  }

  deletar(participantePesquisa: ParticipanteLista) {
    let nome = participantePesquisa.NomeFantasia != null && participantePesquisa.NomeFantasia != "" ? participantePesquisa.NomeFantasia : participantePesquisa.RazaoSocial;
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente deletar o participante: " + participantePesquisa.Id + " - " + nome;
    this.bsModalRef.content.confirmar = () => {
      this.participanteService.deletar(participantePesquisa.Id).toPromise().then(() => {
        this.toastr.success('Participante Deletado com sucesso!');
        this.obterTodos(this.pesquisa, 1);
        this.paginacao.paginaAtual = 1;
      },
        (data) => {
          this.toastr.error(data.error.errors[0]);
        }
      );
    }
  }

  public pageChanged(event: any): void {
    this._pagina = event.page; 
    this.obterTodos(this.pesquisa,  this._pagina);
  }
}
